import type { Framework } from '@toeverything/infra';

import { DocCreateMiddleware } from '../doc/providers/doc-create-middleware';
import { DocScope } from '../doc/scopes/doc';
import { EditorSettingService } from '../editor-setting';
import { I18n } from '../i18n';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { WorkspaceRepositoryService } from '../workspace/services/repo';
import { CreationLocationMiddleware } from './middleware';
import { BrowserLocationProvider, LocationProvider } from './provider';
import { DocCreationLocationService } from './service';
import { DocLocationUpdateService } from './update';

export { LocationProvider } from './provider';
export { DocCreationLocationService } from './service';
export type { DocCreationLocation } from './types';

export function configureDocLocationModule(framework: Framework) {
  framework
    .impl(LocationProvider, new BrowserLocationProvider())
    .service(DocCreationLocationService, [
      LocationProvider,
      EditorSettingService,
      I18n,
      WorkspaceRepositoryService,
    ])
    .scope(WorkspaceScope)
    .impl(
      DocCreateMiddleware('creation-location'),
      CreationLocationMiddleware,
      [DocCreationLocationService, WorkspaceService]
    )
    .scope(DocScope)
    .service(DocLocationUpdateService, [DocCreationLocationService]);
}
